const pageSize = (state = 16, action) => {
    switch (action.type) {
        case 'PAGE_SIZE':
            return state + 6;
        default:
            return state;
    }
}

export default pageSize;
